"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DLOBOrdersCoder = void 0;
const idl_1 = require("@coral-xyz/anchor/dist/cjs/coder/borsh/idl");
const dlobIdl_json_1 = __importDefault(require("./dlobIdl.json"));
class DLOBOrdersCoder {
    constructor(idl) {
        this.idl = idl;
    }
    static create() {
        return new DLOBOrdersCoder(dlobIdl_json_1.default);
    }
    encode(dlobOrders) {
        const layout = idl_1.IdlCoder.fieldLayout({
            type: {
                vec: {
                    defined: 'DLOBOrder',
                },
            },
        }, this.idl.types);
        const size = 150 * dlobOrders.length;
        const buffer = Buffer.alloc(size);
        const len = layout.encode(dlobOrders, buffer);
        return buffer.slice(0, len);
    }
    decode(buffer) {
        const layout = idl_1.IdlCoder.fieldLayout({
            type: {
                vec: {
                    defined: 'DLOBOrder',
                },
            },
        }, this.idl.types);
        return layout.decode(buffer);
    }
}
exports.DLOBOrdersCoder = DLOBOrdersCoder;
